import { Categories } from "../types/categories";

export type NormalizedRiskMetrics = {
  totalControls: number;
  avgProgressPerc: number;
  completedCount: number;
  completedPerc: number;
  overdueCount: number;
  overduePerc: number;
};

export type SubcategoryMetrics = NormalizedRiskMetrics;

export const normalizeRiskMetrics = (risk: Categories): NormalizedRiskMetrics => ({
  totalControls: risk.totalControls ?? 0,
  avgProgressPerc: risk.avgProgressPerc ?? 0,
  completedCount: risk.completedCount ?? 0,
  completedPerc: risk.completedPerc ?? 0,
  overdueCount: risk.overdueCount ?? 0,
  overduePerc: risk.overduePerc ?? 0,
});

export const aggregateSubcategoryMetrics = (
  risks: Categories[]
): SubcategoryMetrics => {
  const normalized = risks.map(normalizeRiskMetrics);
  const totalControls = normalized.reduce((sum, m) => sum + m.totalControls, 0);

  if (totalControls === 0) {
    return {
      totalControls: 0,
      avgProgressPerc: 0,
      completedCount: 0,
      completedPerc: 0,
      overdueCount: 0,
      overduePerc: 0,
    };
  }

  const completedCount = normalized.reduce((sum, m) => sum + m.completedCount, 0);
  const overdueCount = normalized.reduce((sum, m) => sum + m.overdueCount, 0);
  const weightedProgress = normalized.reduce(
    (sum, m) => sum + m.avgProgressPerc * m.totalControls,
    0
  );

  return {
    totalControls,
    avgProgressPerc: Math.round(weightedProgress / totalControls),
    completedCount,
    completedPerc: completedCount / totalControls,
    overdueCount,
    overduePerc: overdueCount / totalControls,
  };
};

export const formatCountWithPerc = (
  count: number,
  total: number,
  ratio: number
): string => {
  const pct = Math.round(ratio * 100);
  return `${count}/${total} (${pct}%)`;
};
